export default [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavItem',
        auth:0,
        name: 'Dashboard',
        to: '/dashboard',
        icon: 'cil-speedometer'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Auction List',
        auth:0,
        to: '/auctionlist',
        icon: 'cil-description'
      },
      {
        _name: 'CSidebarNavTitle',
        auth:1,
        _children: ['My Team']
      },
      {
        _name: 'CSidebarNavItem',
        auth:1,
        name: 'Loans',
        to: '/my-team/loans',
        icon: 'cil-group'
      },
      {
        _name: 'CSidebarNavItem',
        auth:1,
        name: 'Transfers',
        to: '/my-team/transfers',
        icon: 'cil-fullscreen-exit'
      },
      {
        _name: 'CSidebarNavTitle',
        auth:2,
        _children: ['Admin']
      },
      {
        _name: 'CSidebarNavItem',
        auth:2,
        name: 'Site Vars',
        to: '/admin/site-vars',
        icon: 'cil-group'
      },
      {
        _name: 'CSidebarNavItem',
        auth:2,
        name: 'Team Admin',
        to: '/admin/team-admin',
        icon: 'cil-fullscreen-exit'
      }
    ]
  }
]